import buildBaseApi from './baseApi';

const userExternalApi = buildBaseApi( {
  baseURL: process.env.REACT_APP_API_URL!,
  handle401: false,
} );

export default userExternalApi;
